import { render, staticRenderFns } from "./TaskListOrders.vue?vue&type=template&id=c8ecfd5a"
import script from "./TaskListOrders.vue?vue&type=script&lang=js"
export * from "./TaskListOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports